import { useSelector } from "react-redux";

import ServiceCatalogCard from "./ServiceCatalogCard";
import { selectActiveDepartments } from "../departments/departmentsSlice";
import { PropsWithClassName } from "../../common/types/PropsWithClassName";

export default function ServiceCatalogCards({ className }: PropsWithClassName) {
  const departments = useSelector(selectActiveDepartments);

  return (
    <>
      {departments.map((department) => (
        <div key={department.id} className={`${className}`}>
          <ServiceCatalogCard department={department} />
        </div>
      ))}
    </>
  );
}
